<nz-form-item class="label-on-top">
  <nz-form-label *ngIf="label" [nzRequired]="isRequired(control)">
    {{ label }}
  </nz-form-label>
  <nz-form-control [nzErrorTip]="errorTemplate" [nzValidateStatus]="control">
    <nz-date-picker
      [formControl]="control"
      [nzSize]="size"
      [nzDisabled]="isDisabled"
      [nzPlaceHolder]="placeholder"
      [nzDropdownClassName]="placement"
    >
    </nz-date-picker>
  </nz-form-control>
  <ng-template #errorTemplate>
    {{ control.errors | formError }}
  </ng-template>
</nz-form-item>
